<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useMutation, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast, successToast} from "@/composables/useToasts";

defineProps({
  action: {
    required: true,
    type: Object,
  }
});

const queryClient = useQueryClient();

const {mutate: unhideAction} = useMutation({
  mutationFn:  actionId => axios.post(`/ajax/v2/actions/${actionId}/unhide`),
  onMutate: async (actionId) => {
    await queryClient.cancelQueries({ queryKey: ['hidden-actions'] });
    await queryClient.cancelQueries({ queryKey: ['actions'] });

    const previousActions = queryClient.getQueryData(['hidden-actions']);

    queryClient.setQueryData(['hidden-actions'], (old) =>
      old ? old.filter(action => action.id !== actionId) : []
    );

    successToast('Action unhidden');

    return { previousActions }
  },
  onError: (error, _, context) => {
    const {message} = error.response.data;

    errorToast(message ?? 'Something went wrong unhiding action');

    queryClient.setQueryData(['hidden-actions'], context.previousActions);
  },
  onSettled: () => {
    queryClient.invalidateQueries({ queryKey: ['hidden-actions'] });
    queryClient.invalidateQueries({ queryKey: ['actions'] });
  },
});
</script>

<template>
  <DefaultButton
    variant="primary-inverted"
    size="small"
    class="tw-flex tw-items-center tw-gap-2 tw-text-base!"
    @click="unhideAction(action.id)"
  >
    <svg-vue
      icon="icons/eye-hidden"
      class="tw-h-5 tw-w-5"
    />
    <span>Unhide</span>
  </DefaultButton>
</template>
